export default (function (){

    const defaults = {
        selectors: {
            elements: ".mainStage",
            items: ".mainStage-image",
        },
        timing: {
            delay: 7000,
            duration: 1500,
        },
    };

    function init() {

        const elements = document.querySelectorAll(defaults.selectors.elements);

        for (var i = 0; i < elements.length; i++) {
            new SlideShow(elements[i]);
        }

    }

    const SlideShow = function(element) {

        this.element = element;

        this.settings = {
            timing: {
                delay: 1000,
                duration: 500,
            },
        };

        if (this.element.dataset.delay) {
            this.settings.timing.delay = parseInt(this.element.dataset.delay);
        }

        if (this.element.dataset.duration) {
            this.settings.timing.duration = parseInt(this.element.dataset.duration);
        }

        this.element.style.transitionDuration = this.settings.timing.duration + "ms, 0s";

        this.items = [];

        const items = element.querySelectorAll(defaults.selectors.items);

        for (var i = 0; i < items.length; i++) {
            const item = items[i];
            this.items.push(item);
        }

        if (this.items.length > 1) {
            this.start();
        }

    }

    SlideShow.prototype.start = function() {

        if (typeof this.currentItem === "undefined") {
            this.currentItem = 0;
        }

        this.items[this.currentItem].dataset.current = "true";
        this.element.dataset.active = "true";

        this.interval = setInterval(
            () => {
                this.update();
            },
            this.settings.timing.delay + this.settings.timing.duration
        );

    }

    SlideShow.prototype.update = function() {

        this.items[this.currentItem].dataset.current = "false";

        this.currentItem++;

        if (this.currentItem >= this.items.length){ 
            this.currentItem = 0;
        }

        this.items[this.currentItem].dataset.current = "true";

    }

    return {
        init: init
    }

})();
